export const LOGGER_ARR_SIZE = 5;
export const LOGGER_PUSH_TIME = 10;
export const URL = '/api/log';
export const EVENT_LOGGER_URL = 'https://test.com';
export const ERROR_LOGGER_URL = 'https://test.com';
export const SERVICE_NAME = process.env.NEXT_PUBLIC_PORTAL ?? 'PORTAL';
